import { render, staticRenderFns } from "./next-opponent.vue?vue&type=template&id=64963b88&scoped=true&"
import script from "./next-opponent.vue?vue&type=script&lang=js&"
export * from "./next-opponent.vue?vue&type=script&lang=js&"
import style0 from "./next-opponent.vue?vue&type=style&index=0&id=64963b88&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64963b88",
  null
  
)

export default component.exports